export function getSourceAccountTagsV2(send) {
  return (sourceAccountId, query, ...args) =>
    send(
      {
        path: '/v2/sourceAccounts/{sourceAccountId}/tags',
        pathParameters: { sourceAccountId },
        type: 'get',
        query: query,
        body: undefined,
        headers: undefined,
        auth: 'oauth2',
        contentType: undefined,
      },
      ...args
    );
}
